import React from "react";

import Section from "./Section";

const About = () => {
  return (
    <Section bgColor="bg-navy" textColor="text-navy" comment="About Us">
      <h2 id="about" className="text-white font-otomanopee mb-16">
        ETCとは？
      </h2>
      <p className="text-white mb-4">
        関西の学生の有志で主催するユーフォとチューバだけの演奏会 Euphonium &
        Tuba Carnival、略して「ETC」
        です！
        ユーフォとチューバの豊かなサウンドをお届けします！
      </p>
      <p className="text-white mb-4">
        第1回を2019年に開催し好評でしたが、それからは2年連続コロナ禍のため頓挫。今年は3度目の復活を目指します。
      </p>
      <p className="text-white mb-4">
        高校生から社会人まで、中低音を愛する者なら、どなたでも参加可能です。
      </p>
      <p className="text-white mb-4">
        みなさんのご参加、そして演奏会へのご来場をお待ちしています！
      </p>
    </Section>
  );
};

export default About;
